import TaskPanel from '../TaskPanel'
import {connect} from '../../../redux/utils'
import {
    canModifyAnyManager,
    canModifyAnyUser,
    canMoveTask,
    canReopenProject,
    getAssignedManagers,
    getAssignedUsers,
    getAuditActions,
    getBillingType,
    getCommentsCount,
    getCustomerName,
    getEstimatedTime,
    getLastAuditActions,
    getLastTaskPanelTabKey,
    getOpenTaskId,
    getProjectName,
    getReportedTimeComments,
    getSortingSettings,
    getSpentTime,
    getTaskDeadline,
    getTaskDescription,
    getTaskDetails,
    getTaskExecutorsSummary,
    getTaskName,
    getTaskNewComment,
    getTaskPanelErrors,
    getTaskPanelTabKey,
    getTaskStatusId,
    isAllAuditHistoryLoaded,
    isAllTimeCommentsLoaded,
    isDeadlineUpdating,
    isDescriptionUpdating,
    isEditTaskPanelEditable,
    isEstimateUpdating,
    isMoveToDialogLoading,
    isNameUpdating,
    isSendingComment,
    isShowNewCommentInput,
    isStatusUpdating,
    isTaskCompleted,
    isTaskDeletedSuccessfully,
    isTaskDeletedUnsuccessfully,
    isTaskManageable,
    isTimeAndCommentsLoading,
    isTypeOfWorkUpdating,
} from './selectors'
import {
    copyTask,
    deleteAssignedManager,
    deleteAssignedUser,
    deleteTask,
    loadTaskAuditHistory,
    loadTimeComments,
    moveTask,
    openLastTaskPanelTab,
    reloadComments,
    resetDeletionStatus,
    saveComment,
    saveEditingComment,
    saveSortingSettings,
    setLastTaskPanelTab,
    setTaskPanelTab,
    toggleNewCommentInput,
    updateAssignedManagers,
    updateAssignedUsers,
    updateDeadline,
    updateDescription,
    updateEstimate,
    updateName,
    updateNewCommentText,
    updateStatus,
    updateTypeOfWork,
    copyLinkTo,
} from './actions'
import {bindActionCreators} from 'redux'
import {
    canAccessSomeTeamAssignment, canGenerateMoneyReports, canManageAccountsAndPermissions, getLoggedInUser,
    hasManageScopeRights
} from '../../../loggedInUser/selectors'
import {isBTYEnabled, isESTEnabled, isTTAEnabled, isTWSEnabled, isTZGEnabled, isUGREnabled, isURAEnabled, isWASEnabled} from '../../../features/selectors'
import {getTimeZoneGroups, getUserGroups, getWorkflowStatuses} from '../../../entities/selectors'
import {
    getCustomerIdsWhereCanManageLeastOneProject,
    getEditableCustomerIds,
    getEditableProjectIds,
    getEditableProjectIdsWithExcludeSelf,
} from '../../../taskManagement/common/selectors'
import {toast} from '../../../toasts/actions'
import {getFirstCompletedWorkflowStatus} from '../../../workflowStatus/selectors'

export default connect(
    state => ({
        loggedInUser: getLoggedInUser(state),
        sendingComment: isSendingComment(state),
        showNewCommentInput: isShowNewCommentInput(state),
        newCommentText: getTaskNewComment(state),

        canEdit: isEditTaskPanelEditable(state),
        openTaskId: getOpenTaskId(state),
        name: getTaskName(state),
        completed: isTaskCompleted(state),
        workflowStatusId: getTaskStatusId(state),
        deadline: getTaskDeadline(state),
        typeOfWork: getBillingType(state),
        estimatedTime: getEstimatedTime(state),
        spentTime: getSpentTime(state),
        description: getTaskDescription(state),
        commentsCount: getCommentsCount(state),

        projectName: getProjectName(state),
        customerName: getCustomerName(state),

        nameUpdating: isNameUpdating(state),
        deadlineUpdating: isDeadlineUpdating(state),
        typeOfWorkUpdating: isTypeOfWorkUpdating(state),
        estimateUpdating: isEstimateUpdating(state),
        descriptionUpdating: isDescriptionUpdating(state),
        statusUpdating: isStatusUpdating(state),
        moveToDialogLoading: isMoveToDialogLoading(state),

        errors: getTaskPanelErrors(state),

        isBTYEnabled: isBTYEnabled(state),
        isURAEnabled: isURAEnabled(state),
        isTWSEnabled: isTWSEnabled(state),
        isESTEnabled: isESTEnabled(state),
        isWASEnabled: isWASEnabled(state),
        isTTAEnabled: isTTAEnabled(state),

        assignedUsers: getAssignedUsers(state),
        assignedManagers: getAssignedManagers(state),
        userGroupsEnabled: isUGREnabled(state),
        timeZoneGroupsEnabled: isTZGEnabled(state),
        userGroups: getUserGroups(state),
        timeZoneGroups: getTimeZoneGroups(state),
        canModifyAnyUser: canModifyAnyUser(state),
        canModifyAnyManager: canModifyAnyManager(state),

        taskDetails: getTaskDetails(state),
        taskDeletedSuccessfully: isTaskDeletedSuccessfully(state),
        taskDeletedUnsuccessfully: isTaskDeletedUnsuccessfully(state),

        copyMoveSelectorsCustomerIds: getCustomerIdsWhereCanManageLeastOneProject(state),
        copyMoveSelectorsProjectIds: getEditableProjectIdsWithExcludeSelf(state),
        editableCustomersIds: getEditableCustomerIds(state),
        editableProjectsIds: getEditableProjectIds(state),

        auditActions: getAuditActions(state),
        lastAuditActions: getLastAuditActions(state),
        allAuditHistoryLoaded: isAllAuditHistoryLoaded(state),

        canReopenProject: canReopenProject(state),
        canMoveTask: canMoveTask(state),
        canGenerateMoneyReports: canGenerateMoneyReports(state),
        canManageAccountsAndPermissions: canManageAccountsAndPermissions(state),
        hasManageScopeRights: hasManageScopeRights(state),
        taskInManageAssignments: isTaskManageable(state),
        executorsSummary: getTaskExecutorsSummary(state),
        reportedTimeComments: getReportedTimeComments(state),
        allTimeCommentsLoaded: isAllTimeCommentsLoaded(state),
        timeAndCommentsLoading: isTimeAndCommentsLoading(state),
        sortingSettings: getSortingSettings(state),

        currentTabKey: getTaskPanelTabKey(state),
        lastSelectedTabKey: getLastTaskPanelTabKey(state),

        defaultCompletedStatus: getFirstCompletedWorkflowStatus(state),

        hasSomeTeamAssignment: canAccessSomeTeamAssignment(state),
}),
    dispatch => ({
        saveComment: bindActionCreators(saveComment, dispatch),
        saveEditingComment: bindActionCreators(saveEditingComment, dispatch),
        toggleNewCommentInput: bindActionCreators(toggleNewCommentInput, dispatch),
        updateNewCommentText: bindActionCreators(updateNewCommentText, dispatch),
        reloadComments: bindActionCreators(reloadComments, dispatch),
        deleteAssignedUser: bindActionCreators(deleteAssignedUser, dispatch),
        updateAssignedUsers: bindActionCreators(updateAssignedUsers, dispatch),
        deleteAssignedManager: bindActionCreators(deleteAssignedManager, dispatch),
        updateAssignedManagers: bindActionCreators(updateAssignedManagers, dispatch),
        deleteTask: bindActionCreators(deleteTask, dispatch),
        resetDeletionStatus: bindActionCreators(resetDeletionStatus, dispatch),
        moveTask: bindActionCreators(moveTask, dispatch),
        copyTask: bindActionCreators(copyTask, dispatch),
        loadTaskAuditHistory: bindActionCreators(loadTaskAuditHistory, dispatch),
        setTaskPanelTab: bindActionCreators(setTaskPanelTab, dispatch),
        setLastTaskPanelTab: bindActionCreators(setLastTaskPanelTab, dispatch),
        openLastTaskPanelTab: bindActionCreators(openLastTaskPanelTab, dispatch),
        loadTimeComments: bindActionCreators(loadTimeComments, dispatch),
        saveSortingSettings: bindActionCreators(saveSortingSettings, dispatch),
        toast: bindActionCreators(toast, dispatch),
        ...bindActionCreators({
            updateStatus,
            updateName,
            updateDeadline,
            updateTypeOfWork,
            updateEstimate,
            updateDescription,
        }, dispatch),
    })
)(TaskPanel)


// WEBPACK FOOTER //
// ./web/js/panels/task/editPanel/EditTaskPanel.js